import { Component, HostBinding, OnInit } from '@angular/core';
import { SignalrService } from './services/signalr.service';
import { filter, map } from 'rxjs/operators';
import { VERSION } from 'environments/version';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent
} from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from './app.reducer';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreadcrumbsService } from './services/breadcrumbs.service';
import { debounceTime, take, tap } from 'rxjs';
import { CartService } from 'app/services/cart.service';
import { ApiService } from 'app/services/api.service';
import {
  discountsClearAction,
  discountsShouldBeUpdatedAction,
  discountsUpdateAction,
} from 'app/store/discounts.actions';
import { LoyaltySystem } from 'app/models/organizatioMetadata.model';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.scss',
    './app.global.scss'
  ]
})

export class AppComponent implements OnInit {
  isLoading = true;
  @HostBinding('class') cssClass: string;

  constructor(
    private store: Store<AppState>,
    private signalrService: SignalrService,
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    private activatedRoute: ActivatedRoute,
    private cartService: CartService,
    private apiService: ApiService
  ) {

    router.events.pipe(
      untilDestroyed(this),
      filter((e): e is RouterEvent => e instanceof RouterEvent)
    ).subscribe((event) => {
      this.checkRouterEvent(event);
    });
  }

  ngOnInit(): void {
    console.log('APP VERSION OBJECT', VERSION);
    this.store.select('organizationInfo').pipe(
      untilDestroyed(this)
    ).subscribe(organizationState => {
      this.cssClass = organizationState.organizationCode;
    });

    this.store.select('organizationInfo').pipe(
      take(1)
    ).subscribe(organizationState => {
      if (organizationState.organizationInfo?.metadata.discount.loyaltySystem != LoyaltySystem.No)
      {
        this.cartService.CreateOrderRequestAsync()
          .pipe(
            untilDestroyed(this),
            tap(() => {
              this.store.dispatch(discountsShouldBeUpdatedAction());
            }),
            debounceTime(1000)
          )
          .subscribe(createOrderRequest => {
            if (createOrderRequest) {
              this.apiService.getDiscount(createOrderRequest).pipe().subscribe(discountResponse => {
                const orderDiscountInfo = discountResponse.result;
                if (orderDiscountInfo) {
                  this.store.dispatch(discountsUpdateAction({
                    programs: orderDiscountInfo.programms,
                    productDiscounts: orderDiscountInfo.productDiscounts,
                    freeProductExternalIds: orderDiscountInfo.freeProductExternalIds,
                    warnings: orderDiscountInfo.warnings,
                    totalDiscount: orderDiscountInfo.totalDiscount
                  }));
                }
              });
            }
            this.store.dispatch(discountsClearAction());
          });
      }
    });
  }

  checkRouterEvent(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.isLoading = true;
    }

    if (event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError) {
      this.isLoading = false;
      this.breadcrumbsService.updateBreadcrumbs(this.activatedRoute);
    }
  }
}
